import { Card, Heading, Icon } from '@boltenergy-be/design-system'
import styles from './ReturnLater.module.scss'
import { useTranslation } from 'react-i18next'
import { ReturnLaterProps } from './types'

const EmptyState = ({ description, title, icon }: ReturnLaterProps) => {
  //i18n
  const { t } = useTranslation()

  return (
    <Card className={styles['return-later-card']} as="section" color="soft">
      <Icon className={styles.icon} name={icon || 'hourglass'} />

      <div className={styles.text}>
        <Heading as="h6">{title || t(($) => $.returnLater.title)}</Heading>
        <p className={styles.description}>{description}</p>
      </div>
    </Card>
  )
}

export default EmptyState
